export function stripAlignmentChars(marbles: string) {
  return marbles.replace(/^[ ]+/, '');
}
